<template>
  <!-- sticky begin -->
  <div class="position-sticky" style="top:-40px; z-index:100;">
    <header>
      <div class="w-100 overflow-hidden" style="margin-bottom: -38px; height:86px;">
        <BackGroundImg :headerBackground="headerBackground" />
      </div>
      <div class="container-fluid p-0 w-100 border-0 position-absolute" style="color: #ffffff; top:0; z-index:1;">
        <!-- 預設樣式 begin -->
        <div :class="[isSearching ? 'd-none' : '']" class="row no-gutters align-items-center" style="min-height: 48px;">
          <div class="col-3">
            <div class="py-2 px-3">
              <span class="material-icons" @click="$router.go(-1)">
                keyboard_arrow_left
              </span>
            </div>
          </div>
          <div class="col-6 text-center">
            <span class="font-weight-bold mx-1 align-middle">{{ title }}</span>
          </div>
          <div class="col-3 text-right">
            <div class="py-2 px-3">
              <span class="material-icons" @click="isSearching = true">
                search
              </span>
            </div>
          </div>
        </div>
        <!-- 預設樣式 end -->
        <!-- 搜尋樣式 begin -->
        <div :class="[isSearching ? '' : 'd-none']" class="row no-gutters align-items-center" style="min-height: 48px;">
            <b-form-group class="w-100 px-3 mb-0 mt-2">
              <div class="input-icon">
                <b-form-input v-model="keyword" :placeholder="$t('redeem.keyword-placeholder')" class="border-0 pr-5" trim lazy></b-form-input>
                <div class="input-icon-group">
                  <a class="p-2" href="javascript: void(0)" @click="isSearching = false; keyword = '';">
                    <span class="material-icons text-secondary md-18">close</span>
                  </a>
                  <a class="p-2" href="javascript: void(0)">
                    <span class="material-icons text-secondary">search</span>
                  </a>
                </div>
              </div>
            </b-form-group>
        </div>
        <!-- 搜尋樣式 end -->
      </div>
    </header>
    <!-- tab begin -->
    <DeptTab class="font-size-md nav-tabs-light position-relative" style="z-index:10" @changeDetailDepts="changeDetailDepts" />
    <!-- tab end -->
  </div>
  <!-- sticky end -->
</template>

<script>
import BackGroundImg from '@/components/mcf/BackGroundImg.vue';
import DeptTab from '@/components/redeem/DeptTab.vue';

export default {
  components: {
    BackGroundImg,
    DeptTab,
  },
  data() {
    return {
      // 是否搜尋中
      isSearching: false,
      // 搜尋關鍵字
      keyword: '',
    };
  },
  props: {
    title: String,
    headerBackground: String,
  },
  watch: {
    // eslint-disable-next-line func-names
    keyword() {
      const vm = this;
      vm.$store.commit('redeemItem/set', { name: 'keyword', value: vm.keyword });
    },
  },
  methods: {
    // 回傳子分類列表
    changeDetailDepts(detailDepts) {
      this.$emit('changeDetailDepts', detailDepts);
    },
  },
};
</script>

<style scoped>
.te-tabs-mcf .nav-tabs a {color: rgba(255,255,255,0.73);}
.nav-tabs .nav-link.active {color: rgba(255,255,255,1.0);}
.McfBgImg{ transform:scale(1.5); -webkit-filter: brightness(.5) blur(4px);}
</style>
